import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { DateService } from 'src/app/services/date.service';
import { facilityService } from 'src/app/services/facility.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { BookNewMeetingRoomComponent } from 'src/app/modal/book-new-meeting-room/book-new-meeting-room.component';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';
import { MeetingService } from 'src/app/services/meeting.service';

@Component({
  standalone: false,
  selector: 'app-details-meeting-room',
  templateUrl: './details-meeting-room.component.html',
  styleUrls: ['./details-meeting-room.component.scss']
})
export class DetailsMeetingRoomComponent implements OnInit {
  private subscriptions = new Subscription();
  @ViewChild('contentActivation', { static: false }) content: ElementRef;
  id: any;
  data: any = [];
  detail: any = [];
  tempDate: any;
  isLoaded: boolean = false;
  closeResult: string;
  parkList: any;
  history: boolean;
  showCal: boolean = true;
  showPolicy: boolean;
  type: any;
  meetingRoomDetails: any;
  FacilityList: any;
  FacilityTypeId: any;
  urlIndex = 0;
  TempRateCardHourCal: any[] = [];
  fromDayOperation: any;
  toDayOperation: any;
  meetingDayFromName: string;
  meetingDayToName: string;
  meetingRoomCreate: any;
  meetingRoomRemove: any;
  meetingRoomEdit: any;
  meetingRoomView: any;
  selectedAminity: any[] = [];

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private apiSrvice: facilityService,
    private appStateSrv: AppStateProvider,
    private activatedRoute: ActivatedRoute,
    private dateSrv: DateService,
    private sideNavService: SidenavService,
    private rolebasedactionService: RolebasedactionService,
    private meetingService: MeetingService,
  ) { }

  ngOnInit(): void {
    this.meetingRoomCreate = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:Create');
    this.meetingRoomRemove = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:Remove');
    this.meetingRoomEdit = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:Edit');
    this.meetingRoomView = this.rolebasedactionService.checkUserRolePermissionExits('Meeting Room:View');
    this.type = 'cal'
    this.activatedRoute.queryParams.subscribe((res) => {
      this.meetingRoomId = res.id;
    });
    this.getMeetingRoomDetails(this.meetingRoomId);
  }

  editDetail(id) {
    console.log(id);
    this.router.navigate(['meeting-room/create-meeting-room'], {
      queryParams: { meetingRoomId: this.meetingRoomId },
    });
  }

  ViewBoooking() {
    localStorage.setItem("viewMeetingRoomName", this.meetingRoomDetails?.roomName)
    this.router.navigate(['/meeting-room/view-meeting-room-booking'], {
      queryParams: { meetingRoomId: this.meetingRoomId },
    });
  }

  formatDate(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
    else {
      this.tempDate = date.split('T')[1].split(':')
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM'
      return (this.tempDate[0] > 12) ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type

    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getMeetingRoomDetails(meetingRoomId) {

    this.selectedAminity = [];

    this.meetingService.getMeetingRoomDetails(meetingRoomId).subscribe((res) => {
      this.meetingRoomDetails = res;

      console.log(this.meetingRoomDetails);

      for (let h = 0; h < this.meetingRoomDetails?.parkMeetingRoomTimeSlabList.length; h++) {
        const tempTimeSlabRateDetails = {
          isActive: true,
          roomTimeSlabId: this.meetingRoomDetails.parkMeetingRoomTimeSlabList[h].roomTimeSlabId
            ? this.meetingRoomDetails.parkMeetingRoomTimeSlabList[h].roomTimeSlabId
            : null,
          hourRate: this.meetingRoomDetails.parkMeetingRoomTimeSlabList[h].rateHourly
            ? this.meetingRoomDetails.parkMeetingRoomTimeSlabList[h].rateHourly
            : null,
          stimerate: this.meetingRoomDetails.parkMeetingRoomTimeSlabList[h].fromTime
            ? this.meetingRoomDetails.parkMeetingRoomTimeSlabList[h].fromTime
            : null,
          etimerate: this.meetingRoomDetails.parkMeetingRoomTimeSlabList[h].toTime
            ? this.meetingRoomDetails.parkMeetingRoomTimeSlabList[h].toTime
            : null,
          // createdBy: 1,
          // modifiedBy: 1,
          // meetingRoomId: this.meetingRoomId,
        };
        this.TempRateCardHourCal.push(tempTimeSlabRateDetails);
      }
      if (this.meetingRoomDetails?.fromDayOperation != null && this.meetingRoomDetails?.fromDayOperation == "0") {
        this.meetingDayFromName = "Sunday";
      }
      if (this.meetingRoomDetails?.fromDayOperation != null && this.meetingRoomDetails?.fromDayOperation == "1") {
        this.meetingDayFromName = "Monday";
      }
      if (this.meetingRoomDetails?.fromDayOperation != null && this.meetingRoomDetails?.fromDayOperation == "2") {
        this.meetingDayFromName = "Tuesday";
      }
      if (this.meetingRoomDetails?.fromDayOperation != null && this.meetingRoomDetails?.fromDayOperation == "3") {
        this.meetingDayFromName = "Wednesday";
      }
      if (this.meetingRoomDetails?.fromDayOperation != null && this.meetingRoomDetails?.fromDayOperation == "4") {
        this.meetingDayFromName = "Thursday";
      }
      if (this.meetingRoomDetails?.fromDayOperation != null && this.meetingRoomDetails?.fromDayOperation == "5") {
        this.meetingDayFromName = "Friday";
      }
      if (this.meetingRoomDetails?.fromDayOperation != null && this.meetingRoomDetails?.fromDayOperation == "6") {
        this.meetingDayFromName = "Saturday";
      }
      if (this.meetingRoomDetails?.toDayOperation != null && this.meetingRoomDetails?.toDayOperation == "0") {
        this.meetingDayToName = "Sunday";
      }
      if (this.meetingRoomDetails?.toDayOperation != null && this.meetingRoomDetails?.toDayOperation == "1") {
        this.meetingDayToName = "Monday";
      }
      if (this.meetingRoomDetails?.toDayOperation != null && this.meetingRoomDetails?.toDayOperation == "2") {
        this.meetingDayToName = "Tuesday";
      }
      if (this.meetingRoomDetails?.toDayOperation != null && this.meetingRoomDetails?.toDayOperation == "3") {
        this.meetingDayToName = "Wednesday";
      }
      if (this.meetingRoomDetails?.toDayOperation != null && this.meetingRoomDetails?.toDayOperation == "4") {
        this.meetingDayToName = "Thursday";
      }
      if (this.meetingRoomDetails?.toDayOperation != null && this.meetingRoomDetails?.toDayOperation == "5") {
        this.meetingDayToName = "Friday";
      }
      if (this.meetingRoomDetails?.toDayOperation != null && this.meetingRoomDetails?.toDayOperation == "6") {
        this.meetingDayToName = "Saturday";
      }

      this.meetingRoomDetails?.meetingAmenityResponseList.forEach((element) => {
        this.selectedAminity.push(element.amenitiesId);
      });
      console.log(this.selectedAminity);

      localStorage.setItem('meetingOperationFromDay', this.meetingDayFromName);
      localStorage.setItem('meetingOperationToDay', this.meetingDayToName);
      localStorage.setItem("meetingmaintainenceStartDate", this.meetingRoomDetails?.maintainenceStartDate);
      localStorage.setItem("meetingmaintainenceEndDate", this.meetingRoomDetails?.maintainenceEndDate);
      localStorage.setItem("meetingmaintainenceStartTime", this.formatDate(this.meetingRoomDetails?.operationStartTime, 'time'));
      localStorage.setItem("meetingmaintainenceEndTime", this.formatDate(this.meetingRoomDetails?.operationEndTime, 'time'));
      localStorage.setItem("meetingRoomMaxDuration", this.meetingRoomDetails?.maxBookingDuration ?? '12');
    });
  }

  // Method to check if an amenity is selected
  isSelected(amenitiesId: string): boolean {
    return this.selectedAminity.includes(amenitiesId);
  }

  deleteMeetingRoom() {
    this.deleteMeetingRoomMethod(this.meetingRoomId);
  }

  meetingRoomId(meetingRoomId: any) {
    throw new Error('Method not implemented.');
  }

  deleteMeetingRoomMethod(meetingRoomId) {
    localStorage.setItem("viewMeetingRoomName", this.meetingRoomDetails?.roomName);
    const body = {
      parkMeetingRoomId: meetingRoomId
    }
    this.meetingService.deleteParkMeetingRoom(body).subscribe((res) => {
      this.router.navigate(['/meeting-room/view-meeting-room'])
      // if (res.isValid) {
      //   this.router.navigate(['meeting-room/view-meeting-room']);
      // } else {
      //   this.router.navigate(['meeting-room/view-meeting-room-booking'], {
      //     queryParams: { meetingRoomId: meetingRoomId },
      //   });
      // }
    });
  }

  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'custom-class',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openModal() {
    this.open(this.content);
  }

  selectType(type) {
    console.log(type.target.value)
    this.type = type.target.value;
    if (type.target.value == 'cal') {
      this.showCal = true;
      this.showPolicy = false;
    } else {
      this.showCal = false;
      this.showPolicy = true;
    }
  }

  displayImg(i) {
    this.urlIndex = i
  }

  bookMeetingRoom() {

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(BookNewMeetingRoomComponent, modalOptions);
    modalRef.componentInstance.parkMeetingRoomId = this.meetingRoomId;
    modalRef.componentInstance.userId = localStorage.getItem('claAdminId');
    modalRef.componentInstance.meetingDayFromName = this.meetingDayFromName;
    modalRef.componentInstance.meetingDayToName = this.meetingDayToName;
    modalRef.componentInstance.meetingRoomStartTime = this.formatDate(this.meetingRoomDetails?.operationStartTime, 'time');
    modalRef.componentInstance.meetingRoomEndTime = this.formatDate(this.meetingRoomDetails?.operationEndTime, 'time');
    modalRef.componentInstance.maintainenceStartDate = this.formatDate(this.meetingRoomDetails?.parkMeetingRoomMaintainanceDetail.maintananceStarDateTime, 'date');
    modalRef.componentInstance.maintainenceEndDate = this.formatDate(this.meetingRoomDetails?.parkMeetingRoomMaintainanceDetail.maintananceEndDateTime, 'date');
    modalRef.componentInstance.isMeetingRoomEdit = 'no';
    modalRef.componentInstance.bookedStartDateTime = '';
    modalRef.componentInstance.bookedEndDateTime = '';
    modalRef.componentInstance.purpose = '';
    modalRef.componentInstance.remarks = '';
    modalRef.componentInstance.meetingRoomDuration = this.meetingRoomDetails?.minBookingDuration; //min duration added
    modalRef.componentInstance.meetingRoomDurationMax = this.meetingRoomDetails?.maxBookingDuration; //max duration added
    modalRef.componentInstance.bookedByUserId = localStorage.getItem('claAdminId');
  }

  blockedMeetingRoom() {
    localStorage.setItem("viewMeetingRoomName", this.meetingRoomDetails?.roomName)
    this.router.navigate(['/meeting-room/view-blocked-meeting-room'], {
      queryParams: { meetingRoomId: this.meetingRoomId },
    });
  }
}

